import { isNumber, sum } from 'lodash'

import { calculateTripPrice, getLeaderName } from 'Lib/TripTools'

import ActionTypes from '../../actions/ActionTypes'
import { getText, getTextWithTokens } from '../../lib/text.js'
import { updateTrip } from '../../ducks/trips'
import { cancelTripTasks } from '../../ducks/tasks'

import { 
  getStatusValue, getStatusLabel,
  UNKNOWN, OTHER, NEW, PROPOSAL_SENT,
  NEGOTIATING, CONTRACT_SENT, ACCEPTED_NO_BOND,
  BOND_SENT, FIRST_PAYMENT_SENT, ALL_PAID,
  DONE, LOST 
} from '../../trips/TripStatus'

const gotoAction = (pathname) => ({
  type: "@@router/LOCATION_CHANGE", // #TODO this shoulnt be hardcoded
  pathname,
  action: "PUSH",
  key: pathname
})

// how to display a prompt

const addPrompt = (dispatch, title, text, buttons) => dispatch({
  type: ActionTypes.ADD_PROMPT, 
  payload: { title, text, buttons } 
})

const addCustomPrompt = (dispatch, key, props) => dispatch({
  type: ActionTypes.ADD_PROMPT, 
  payload: { custom: true, key, props } 
})

/**
 * Prompt-rules middleware
 */

const promptsMiddleware = ({ getState, dispatch }) => next => action => {

  if (action.type == ActionTypes.UPDATE_ONE_TRIPS) {
    const trip = getState().trips[action.id]

    const tripPrice = () => calculateTripPrice(
      trip, 
      getState().routes[trip.mainRoute], 
      getState().activities, 
      getState().cities
    ).finalE

    // on status changes...

    if (action.payload && isNumber(action.payload.status) && action.payload.status != trip.status) {
      // paso a fianza pagada, pero falta fianza
      if (action.payload.status == BOND_SENT && trip.payments.length == 0) {
        addPrompt(
          dispatch,
          getText("Pueden faltar pagos"),
          getText("Recuerda también introducir la fianza en la lista de pagos del cliente"),
          [ { k: "x", text: getText("OK"), action: null } ]
        )
      }
      
      // paso a todo pagado, pero falta dinero
      if (action.payload.status == ALL_PAID && sum(trip.payments.map(x => x.eur)) < tripPrice()) {
        addPrompt(
          dispatch, 
          getText("Pueden faltar pagos"),
          getTextWithTokens(
            "La ruta de este cliente cuesta $$€ pero sólo tiene pagado hasta $$€. Recuerda introducir sus pagos.", 
            [tripPrice(), sum(trip.payments.map(x => x.eur))]
          ),
          [ { k: "x", text: getText("OK"), action: null } ]
        )
      }

      // cliente cerrado, qué pasa con sus tareas
      if (action.payload.status == DONE && trip.payments.length == 0) {
        addPrompt(
          dispatch,
          getText("Terminar tareas"), 
          getText("Parece que el cliente ha sido cerrado, ¿deseas terminar todas sus tareas?"), 
          [
            { k: "c", text: getText("Cambiar"), action: cancelTripTasks(trip._id) }, 
            { k: "x", text: getText("No cambiar"), action: null }
          ]
        )
      } 

      // Trips nombres
      if (
        !trip.tags["SPOT"]
        && action.payload.status >= BOND_SENT 
        && action.payload.status != LOST && action.payload.status != OTHER
        && !trip.officialName && !action.payload.officialName && !getLeaderName(trip)
      ) {
        addPrompt(
          dispatch,
          getText("Falta información del cliente"),
          getText("Antes de seguir con el proceso de este cliente es necesario indicar todos los nombres (incluyendo líder y nombre oficial)"),
          [
            { k: "x", glyph: "remove-sign", text: getText("No puedo arreglarlo ahora"), action: null },
            { k: "c", style: "primary", glyph: "share", text: getText("Voy a arreglarlo"), action: gotoAction(`/private/trip/${trip._id}`) }, 
          ]
        )
      }

      // Trips sin apodo
      else if (
        !trip.tags["SPOT"]
        && action.payload.status > NEW 
        && action.payload.status != LOST && action.payload.status != OTHER
        && !trip.realName && !action.payload.realName
      ) {
        addPrompt(
          dispatch,
          getText("Falta información del cliente"),
          getText("Antes de seguir con el proceso de este cliente es necesario indicar un apodo en Pinyin"),
          [
            { k: "x", glyph: "remove-sign", text: getText("No puedo arreglarlo ahora"), action: null },
            { k: "c", style: "primary", glyph: "share", text: getText("Voy a arreglarlo"), action: gotoAction(`/private/trip/${trip._id}`) }, 
          ]
        )
      }

      // Some state changes demand an explanation...
      else if (
        action.payload.status == LOST || action.payload.status == OTHER
      ) {
        addCustomPrompt(
          dispatch,
          "explanation",
          {
            tripId: trip._id,
            tripStatus: action.payload.status,
            tripName: trip.realName || trip.name || "[ Sin nombre ]"
          }
        )
      }
    }

    // pago completo
    if (action.payload && action.payload.payments) {
      const p0 = getState().trips[action.id].payments 
      const p1 = action.payload.payments

      // WARNING: calculation of paid total shouldnt be here
      if (
        p1.length && p1.length > p0.length 
        && trip.status < ALL_PAID
        && sum(p1.map(x => x.eur)) >= tripPrice()
      ) {
        dispatch({
          type: ActionTypes.ADD_PROMPT, 
          payload: {
            title: getText("Estado cliente"), 
            text: getText("Parece que el cliente ha pagado todo, ¿actualizar el estado del cliente?"), 
            buttons: [
              { k: "c", text: getStatusLabel("all_paid"), action: updateTrip(trip._id, { status: ALL_PAID }) }, 
              { k: "x", text: getText("No cambiar"), action: null }
            ]
          }
        })
      }

      // primer pago : fianza 
      else if (p0.length == 0 && p1.length > 0 && trip.status < getStatusValue("bond_sent")) {
        dispatch({
          type: ActionTypes.ADD_PROMPT, 
          payload: {
            title: getText("Estado cliente"), 
            text: getText("Parece que el cliente ha pagado la fianza, ¿Cambiar el estado del cliente?"), 
            buttons: [
              { k: "a", text: getStatusLabel("bond_sent"), action: updateTrip(trip._id, { status: BOND_SENT }) }, 
              { k: "b", text: getStatusLabel("first_payment_sent"), action: updateTrip(trip._id, { status: FIRST_PAYMENT_SENT }) }, 
              //{ k: "c", text: getStatusLabel("all_paid"), action: updateTrip(trip._id, { status: getStatusValue("all_paid") }) }, 
              { k: "x", text: getText("No cambiar"), action: null }
            ]
              
          }
        })
      }

      // segundo pago
      
      else if (p0.length > 0 && p1.length > p0.length && trip.status < getStatusValue("first_payment_sent")) { 
        dispatch({
          type: ActionTypes.ADD_PROMPT, 
          payload: {
            title: getText("Estado cliente"), 
            text: getText("Parece que el cliente ha pagado parte del viaje, ¿Cambiar el estado del cliente?"), 
            buttons: [
              { k: "b", text: getStatusLabel("first_payment_sent"), action: updateTrip(trip._id, { status: FIRST_PAYMENT_SENT }) }, 
              //{ k: "c", text: getStatusLabel("all_paid"), action: updateTrip(trip._id, { status: getStatusValue("all_paid") }) }, 
              { k: "x", text: getText("No cambiar"), action: null }
            ]
              
          }
        })
      }
    }
  }

  next(action)
}

export default promptsMiddleware

